import { call, put, select, takeLatest } from 'redux-saga/effects'
import { t } from 'i18next'

import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { fetchFailure, fetchRequest, fetchSuccess } from './pollResultsSlice'
import type { PollResultsResponse } from './types'

interface ApiRequest {
  endpoint?: string
  showErrorSnackbar?: boolean
}

interface AuthWithPollResultsRoute {
  extraRoutes?: { devTools?: { communicationBoard?: { pollResults?: string } } }
}

const requestApi = callApi as unknown as (request: ApiRequest) => Generator

export const pollResultsActions = {
  FETCH: 'DEVTOOLS_NEW/COMMUNICATION_BOARD/POLL_RESULTS/FETCH',
}

export function* fetchPollResults(): Generator {
  const { extraRoutes } = (yield select(selectAuthData)) as AuthWithPollResultsRoute
  const endpoint = extraRoutes?.devTools?.communicationBoard?.pollResults

  if (!endpoint) {
    yield put(fetchFailure(t('devToolsNew:communication_board.poll_results.relogin')))
    return
  }

  yield put(fetchRequest())

  try {
    const response = (yield call(requestApi, { endpoint, showErrorSnackbar: false })) as PollResultsResponse

    yield put(fetchSuccess(response?.data?.polls ?? []))
  } catch {
    yield put(fetchFailure(t('devToolsNew:communication_board.poll_results.error')))
  }
}

export default function* pollResultsSagas(): Generator {
  yield takeLatest(pollResultsActions.FETCH, fetchPollResults)
}
